import React, { memo } from 'react';

import SeoTextsBlocks from 'components/SeoTextsBlocks';
import SeoMetaTextBlock from 'components/SeoMetaTextBlock';
import CurrencyYearArchiveBreadCrumbs from 'components/CurrencyYearArchiveBreadCrumbs';

import { BreadCrumbsWrapper } from 'components/FooterStyles';

import { Wrapper } from './styles';

const CurrencyYearArchivePageFooter = memo(() => (
  <Wrapper>
    <SeoMetaTextBlock />
    <SeoTextsBlocks />

    <BreadCrumbsWrapper>
      <CurrencyYearArchiveBreadCrumbs />
    </BreadCrumbsWrapper>
  </Wrapper>
));

export default CurrencyYearArchivePageFooter;
